import React, { useState } from "react";
import VideoPlayer from "./VideoPlayer";

const App = () => {
  const [endpoint, setEndpoint] = useState("");
  const [videos, setVideos] = useState([]);
  const [eventLog, setEventLog] = useState([]);
  const loggedSet = React.useRef(new Set());

  const fetchAds = async () => {
    try {
      const res = await fetch(endpoint);
      const data = await res.json();
      const videoUrls = [];

      data.ads.forEach((ad) => {
        ad.assets.forEach((asset) => {
          if (asset.data?.type === 501 && asset.data.url.endsWith(".mp4")) {
            videoUrls.push({
              url: asset.data.url,
              trackers: ad.eventtrackers || [],
            });
          }
        });
      });

      setVideos(videoUrls);
      setEventLog([]);
      loggedSet.current.clear();
    } catch (err) {
      console.error("Error fetching ads:", err);
      setVideos([]);
      setEventLog([]);
    }
  };

  const logEvent = (label, url) => {
    const key = `${label}:${url}`;
    if (!loggedSet.current.has(key)) {
      loggedSet.current.add(key);
      const time = new Date().toLocaleTimeString();
      setEventLog((prev) => [...prev, `[${time}] ${label}: ${url}`]);
    }
  };

  return (
    <div style={{ padding: "1rem", fontFamily: "Arial, sans-serif" }}>
      <h2>Uncommon Media DOOH </h2>
      <input
        type="text"
        placeholder="Enter API Endpoint"
        value={endpoint}
        onChange={(e) => setEndpoint(e.target.value)}
        style={{ width: "70%", padding: "0.5rem", marginBottom: "1rem" }}
      />
      <button
        onClick={fetchAds}
        style={{ padding: "0.5rem 1rem", marginLeft: "1rem" }}
      >
        Load Ads
      </button>

      <div style={{ display: "flex", marginTop: "2rem" }}>
        {/* TV Screen */}
        <div
          style={{
            flex: 2,
            backgroundColor: "#111",
            borderRadius: "20px",
            boxShadow: "0 0 30px rgba(0,0,0,0.4)",
            padding: "1rem",
            marginRight: "1rem",
            maxWidth: "720px",
          }}
        >
          {videos.length > 0 ? (
            <VideoPlayer videoObjects={videos} onLog={logEvent} />
          ) : (
            <p style={{ color: "#ccc" }}>No videos loaded</p>
          )}
        </div>

        {/* Event Log */}
        <div
          style={{
            flex: 1,
            backgroundColor: "#f5f5f5",
            borderRadius: "10px",
            padding: "1rem",
            height: "400px",
            overflowY: "auto",
            fontSize: "0.9rem",
          }}
        >
          <strong>Event Log:</strong>
          <ul
            style={{ marginTop: "1rem", listStyleType: "none", paddingLeft: 0 }}
          >
            {eventLog.map((log, index) => (
              <li key={index} style={{ marginBottom: "0.5rem" }}>
                {log}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default App;
